import { graphql as gql } from 'react-relay';
const graphql = gql;

export const trackSearchQuery = graphql`
  query trackSearchQuery(
    $offset: Int,
    $count: Int,
    $query: String,
    $filters: TrackSearchFilters,
    $taxonomy_query: TaxonomyQuery,
    $license_params: [LicenseUsageParamsInput],
    $sort: SearchSortOrder,
    $currency: Currency,
  ) {
    viewer {
      ...trackSearch_viewer
    }
  }
`;

export const trackSearchFragment = graphql`
  fragment trackSearch_viewer on Viewer {
    ...signUpCta_viewer
    trackSearch(
      first: $count,
      offset: $offset,
      query: $query,
      filters: $filters,
      taxonomy_query: $taxonomy_query,
      license_params: $license_params,
      sort: $sort,
      currency: $currency,
    ) @connection(key: "trackSearch_trackSearch") {
      edges {
        node {
          ...trackNode @relay(mask: false)
        }
      }
      total
    }

    ...trackSearchTaxonomies_viewer
  }
`;

export const taxonomiesFragment = graphql`
  fragment trackSearchTaxonomies_viewer on Viewer {
    selected_currency
    trackSearch(
      first: $count,
      offset: $offset,
      query: $query,
      filters: $filters,
      taxonomy_query: $taxonomy_query,
      license_params: $license_params,
      sort: $sort,
      currency: $currency,
    ) @connection(key: "trackSearch_trackSearch") {
      edges{
        node{
          id
        }
      }
      taxonomy_cardinalities
      term_cardinalities
    }
  }
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/trackSearch.ts